import { render, staticRenderFns } from "./video-tutorials.vue?vue&type=template&id=00a22956&scoped=true&"
import script from "./video-tutorials.vue?vue&type=script&lang=js&"
export * from "./video-tutorials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a22956",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00a22956')) {
      api.createRecord('00a22956', component.options)
    } else {
      api.reload('00a22956', component.options)
    }
    module.hot.accept("./video-tutorials.vue?vue&type=template&id=00a22956&scoped=true&", function () {
      api.rerender('00a22956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/qm-picture-library/src/components/video-tutorials.vue"
export default component.exports